import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class IPCam_Settings extends Component {
	constructor(props) {
		super(props);
		let uniview_settings = this.props.receiver.getString("uniview_settings");
		let dlink_settings = this.props.receiver.getString("dlink_settings");
		this.arr = [uniview_settings, dlink_settings];
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	accessSettings = (index) => {
		switch (index) {
			case 0:
				// Uniview Settings
				window.app.content_area.current.switch_content.current.handleShowBottomControls();
				this.props.content_handler('UniviewLogin');
				break;
			case 1:
				// DLink Settings
				window.app.content_area.current.switch_content.current.handleHideBottomMenu();
				this.props.content_handler('DLinkCameras');
				break;
		}
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			width: '100%',
			color: 'white',
			fontFamily: "system-ui, -apple-system, -apple-system-font, 'Segoe UI', 'Roboto', sans-serif",
			height: this.props.height,
		}

		let container_style = {
			paddingLeft: 20,
			paddingRight: 20,
			justifyContent: 'center',
			alignItems: 'center',
			height: this.props.height - 86,
			overflow: 'auto',
		}

		let deviceContainer = {
			cursor: 'pointer',
			backgroundColor: '#f9f9f9',
			borderRadius: 10,
			maxWidth: '100%',
			width: 'auto',
			alignItems: 'center',
			justifyContent: 'left',
			position: 'relative',
			display: 'flex',
			marginTop: 10,
			marginBottom: 10,
			padding: 10
		}

		let iconContainer = {
			paddingTop: 10,
			paddingLeft: 10,
			paddingBottom: 10,
			maxWidth: '20%',
			width: '20%',
		}

		let icon_style = {
			width: 52,
			height: 52,
		}

		let delete_icon_style = {
			width: 24,
			height: 24,
		}

		let deviceInfoContainer = {
			marginLeft: 5,
			maxWidth: '60%',
			width: '60%',
			textAlign: 'left',
		}

		let deviceName = {
			fontSize: 16,
			color: 'black',
			fontWeight: 'bold',
			padding: 0,
			margin: 5,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		let modelNumber = {
			// color: 'grey',
			fontSize: 14,
			color: '#BBBBBB',
			margin: 5,
			padding: 0,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		let deleteIconContainer = {
			maxWidth: '20%',
			width: '20%',
			textAlign: 'center'
		}

		return (
			<div>

				<div style={main_content_style} className='slideInDown'>

					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('ipcam_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					{/* List of settings */}
					<div id="deviceContainer" style={container_style}>
						{this.arr.map((device_info, index) => {
							return (
								<div style={deviceContainer} id={index} onClick={() => { this.accessSettings(index) }}>
									<div style={deviceInfoContainer}>
										<p style={deviceName}>{device_info}</p>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}